import React, {forwardRef} from 'react';

import type {ComponentProps, ReactNode} from 'react';


type NativeDivProps = ComponentProps<'div'>;

export interface TabPanelProps extends NativeDivProps {
    /**
     * Content displayed when the associated `<Tab>` is selected. Typically the
     * full page section or form corresponding to the active tab.
     */
    children?: ReactNode,
}

/**
 * Content region associated with a `<Tab>`.
 *
 * Renders a `<div role="tabpanel">`. Link it to its tab by setting `id` on the
 * panel and passing that `id` as `tabPanelId` to the parent `<Tabs>`, which
 * wires `aria-controls` on the active tab automatically.
 */
export const TabPanel = forwardRef<HTMLDivElement, TabPanelProps>(
    function TabPanel({children, ...props}, ref) {

        return (
            <div
                ref={ref}
                role="tabpanel"
                {...props}>
                {children}
            </div>
        );
    },
);

TabPanel.displayName = 'TabPanel';
